exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-switch.is-disabled[data-v-6725ac85]{opacity:1}[data-v-6725ac85] .el-switch__label{cursor:pointer !important}.flex-end[data-v-6725ac85]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);

// exports
